/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {FC, useCallback, useEffect, useRef, useState} from 'react'
import clsx from 'clsx'
import {useDispatch, useSelector} from 'react-redux'
import moment from 'moment'
import './Inbox.module.scss'
import './InboxChatInner.css'
import {useTimezone} from '../../../hooks/useTimezone'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import {
  defaultMessages,
  MessageModel,
  UserInfoModel,
  defaultUserInfos,
  messageFromClient,
  toAbsoluteUrl,
} from '../../../../_metronic/helpers'
import MessageBoxV2 from '../../../Components/MessageBoxV2'
import {
  getRmsChat,
  getSingleChat,
  getSingleRmsChat,
  sendRMSChat,
  sendSMSInbox,
} from './InboxSlice/InboxSlice'
import {AuthenticateUser} from '../../../Utils/_helpers/RoleAndPermission'
import Select from 'react-select'
import {getDedicatedNumber} from '../accounts/DedicatedNumber/DedicatedNumberSlice/DedicatedNumberSlice'
import {getBusinessName} from '../accounts/BusinessName/BusinessNameSlice/BusinessSlice'
import {GeneralDataOFLoginUser} from '../../../Utils/Auth'
import {getAllUserDetails} from '../accounts/Overview/OverviewSlice/UserDetailsSlice'
import Button from 'react-bootstrap/Button'
import ButtonGroup from 'react-bootstrap/ButtonGroup'
import Dropdown from 'react-bootstrap/Dropdown'
import InfiniteScroll from 'react-infinite-scroll-component'
import axios from 'axios'
import {ENV} from '../../../Utils/_helpers/EnvHelper'
import {createFirstLetter} from '../../../Utils/_helpers'
import {
  useLazyExportArchiveMessageQuery,
  useLazyIsHaveArchiveDataQuery,
  useLazyGetRawContactListQuery,
  useUpdateWelcomeMessageSentMutation,
  useGenerateHustleFollowupMutation,
} from '../../../../services/cellcast.v2'
import {Spinner} from 'react-bootstrap'
import {
  useSendQMMutation,
  useLazyGetInboxMessagesQuery,
  useLazyGetInboxMessageDetailsQuery,
} from '../../../../services/cellcast'
import {toast} from 'react-toastify'
import {MessageDeliveryStatus} from '../reports-analytics/Common'
import {useInboxResponsive} from './useInboxResponsive'
import { GLOBAL_SETTINGS_TYPE } from '../../../Utils/Constant/ConstantForWebsite'

const bufferMessages = defaultMessages

const MessageSkeleton = () => {
  return (
    <div className='d-flex flex-column align-items-start mb-4' style={{maxWidth: '70%'}}>
      {/* Avatar + Name */}
      <div className='d-flex align-items-center mb-2 gap-2'>
        <div
          className='rounded-circle bg-secondary'
          style={{width: 32, height: 32, opacity: 0.2}}
        ></div>
        <div
          className='bg-secondary rounded-pill'
          style={{width: 100, height: 12, opacity: 0.2}}
        ></div>
      </div>

      {/* Message bubble skeleton */}
      <div
        className='bg-secondary rounded-pill'
        style={{
          width: '80%',
          height: 24,
          opacity: 0.2,
        }}
      ></div>

      {/* Timestamp placeholder */}
      <div
        className='bg-secondary rounded'
        style={{width: 120, height: 10, marginTop: 8, opacity: 0.1}}
      ></div>
    </div>
  )
}

const InboxChatInner = ({isDrawer = false, data, messengerName, firstTime}: any) => {
  const userName = GeneralDataOFLoginUser()
  const API_DOMAIN = ENV().REACT_APP_DOMAIN
  const [items, setItems] = useState<any>([])
  const [hasMore, setHasMore] = useState(true)
  const [show, setShow] = useState(false)
  const target = useRef(null)
  const [error, setError] = useState<any>({})
  const [page, setPage] = useState<any>({
    page: 2,
    limit: 20,
  })
  const [options, setOptions] = useState({
    webLink: [
      {value: 'https/', label: 'link2'},
      {value: 'https', label: 'link3'},
    ],
    customLanding: [
      {value: 'https/', label: 'link2'},
      {value: 'https', label: 'link3'},
    ],
    optOut: [
      {value: "Reply 'STOP' to opt-out ", label: 'Reply Stop'},
      {value: 'STOP:{stoptxt.cc/}', label: 'custom survey'},
    ],
  })
  const dispatch = useDispatch()
  const userDetail = useSelector(getAllUserDetails)

  const userGlobalSettings = userDetail?.globalSetting
  const replyStopEnabled = userGlobalSettings?.includes(
          GLOBAL_SETTINGS_TYPE.QUICK_SMS_REPLY_STOP_OUTPUT
        ) ?? false

  const [sendData, setSendData] = useState<any>({
    sender: '#SharedNum#',
    contacts: [],
    subject: '',
    media: '',
    message: '',
    optout: '',
    alphaId: '',
    gif: '',
    path: '',
    longUrl: [],
    replyStopToOptOut: replyStopEnabled,
    camp_type: 'sms',
  })

  // Send Later state
  const [sendLater, setSendLater] = useState(false)
  // const chat = useSelector(getSingleChat)

  const {isMobile} = useInboxResponsive()
  const {getUserTimezoneNow, timezoneLabel} = useTimezone()
  const [laterDate, setLaterDate] = useState(getUserTimezoneNow())

  const [chatUpdateFlag, toggleChatUpdateFlat] = useState<boolean>(false)
  const [isRMSChat, setIsRMSChat] = useState<boolean>(false)
  const [message, setMessage] = useState<string>('')
  const [messages, setMessages] = useState<MessageModel[]>(bufferMessages)
  const [userInfos] = useState<UserInfoModel[]>(defaultUserInfos)
  const virtualNumber = useSelector(getDedicatedNumber)
  const scrollRef = useRef<any>(null)
  const [isHaveArchiveMessage, setIsHaveArchiveMessage] = useState(false)
  const [sendSMSInbox, {isLoading: sendLoading}] = useSendQMMutation()
  const [fetchInboxMessages, {data: inboxMessages, isFetching: inboxFetching}] =
    useLazyGetInboxMessagesQuery()
  const [fetchInboxMessageDetails, {data: inboxMessageDetails}] =
    useLazyGetInboxMessageDetailsQuery()

  const [fetchIntervalInboxMessage, {data: fetchIntervalInboxMessageData}] =
    useLazyGetInboxMessagesQuery({
      pollingInterval: 30_000,
    })

  const [fetchIsHaveArchiveMessage, _] = useLazyIsHaveArchiveDataQuery()
  const [downloadArchiveMessage, {isLoading: downloadLoading, isFetching: downloadFetching}] =
    useLazyExportArchiveMessageQuery()

  // welcome message (from Raw Contact, if exists)
  const [fetchRawContacts] = useLazyGetRawContactListQuery()
  const [updateWelcomeMessageSent] = useUpdateWelcomeMessageSentMutation()
  const [welcomeMessage, setWelcomeMessage] = useState<string>('')
  const [hideWelcome, setHideWelcome] = useState<boolean>(false)
  const [rawContactId, setRawContactId] = useState<string>('')
  const [generateFollowup, {isLoading: isGeneratingFollowup}] = useGenerateHustleFollowupMutation()
  const [isSentWelcomeMessage, setIsSentWelcomeMessage] = useState<boolean>(false)

  useEffect(() => {
    if (scrollRef.current && firstTime) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight
    }
    setHasMore(firstTime ? true : hasMore)
    setPage({
      page: 2,
      limit: 20,
    })
  }, [inboxMessages, firstTime])

  useEffect(() => {
    fetchIsHaveArchiveMessage({
      receiver: data,
    }).then((res) => {
      if ('data' in res && res.data) {
        setIsHaveArchiveMessage(res.data?.data || false)
      }
    })

    initialMessageFetch()

    fetchIntervalInboxMessage({
      sortField: 'createdAt',
      sortOrder: 'descending',
      receiver: data,
      page: 1,
      limit: 20,
    })
  }, [data])

  // Load welcomeMessage by receiver (if present in Raw Contacts module)
  useEffect(() => {
    setWelcomeMessage('')
    setRawContactId('')
    if (!data) return
    fetchRawContacts({search: String(data), page: 1, limit: 1})
      .then((res: any) => {
        if ('data' in res) {
          const items = res?.data?.data?.items || []
          if (items.length > 0) {
            const first = items[0] as any
            const wm = first?.welcomeMessage || ''
            const isSent = first?.isSentWelcomeMessage || false
            const contactId = first?._id || ''

            setRawContactId(contactId)

            if (typeof wm === 'string' && wm.trim().length > 0) {
              setWelcomeMessage(wm)
              // Hide welcome message if already sent
              setHideWelcome(isSent)
              setIsSentWelcomeMessage(isSent)
            }
          }
        }
      })
      .catch(() => {})
  }, [data, fetchRawContacts])

  useEffect(() => {
    setItems(fetchIntervalInboxMessageData?.data?.items ?? [])
  }, [fetchIntervalInboxMessageData])

  useEffect(() => {
    // Helper function to get default number for subclient users
    const getDefaultNumber = () => {
      const isSubClient =
        userDetail?.subClientAccountId && userDetail._id !== userDetail.subClientAccountId

      if (isSubClient) {
        // For subclient users, look for subClientDefaults
        const defaultDedicatedNumber = virtualNumber?.find(
          (key: any) => key?.subClientDefaults && key.subClientDefaults[userDetail._id] === true
        )
        // For share credit subaccount, and none-share credit subaccount with DN assigned by owner
        if (defaultDedicatedNumber || (userDetail.ownerId && userDetail._id !== userDetail.ownerId)) {
          return defaultDedicatedNumber
        }
      }
      // For owner users, use existing isDefault logic
      return virtualNumber?.find((key: any) => key?.isDefault)
    }

    const defaultNumber = getDefaultNumber()
    const sendNumber = defaultNumber?.audNumber || '#SharedNum#'
    setSendData({...sendData, sender: sendNumber})
  }, [virtualNumber, userDetail])

  const sendMessage = () => {
    const newMessage: MessageModel = {
      user: 2,
      type: 'out',
      text: message,
      time: 'Just now',
    }

    bufferMessages.push(newMessage)
    setMessages(bufferMessages)
    toggleChatUpdateFlat(!chatUpdateFlag)
    setMessage('')
    setTimeout(() => {
      bufferMessages.push(messageFromClient)
      setMessages(() => bufferMessages)
      toggleChatUpdateFlat((flag) => !flag)
    }, 1000)
  }

  const handleSubmit = (e: any) => {
    // Validate message content
    if (!sendData.message || sendData.message.trim() === '') {
      toast.error('Please enter a message')
      return
    }

    const isDedicatedNumber = virtualNumber?.find((key: any) => key?.isDefault)
      ? 'dedicatedNumber'
      : '#SharedNum#'

    // Prepare schedule data if send later is enabled
    let scheduleAt: Date | undefined = undefined
    if (sendLater) {
      // Validate that the scheduled time is in the future
      if (new Date(laterDate) <= getUserTimezoneNow()) {
        toast.error('Scheduled time must be in the future')
        return
      }

      // Use Date object directly (same as quick message implementation)
      scheduleAt = laterDate
    }

    if (isRMSChat) {
      dispatch(
        sendRMSChat({
          sender: '#SharedNum#',
          senderType: isDedicatedNumber,
          message: sendData.message,
          textMessage: sendData.message,
          contacts: [`${data}`],
          countryCode: '61',
        })
      )
    } else {
      const payload: any = {
        sender: sendData?.sender,
        message: sendData.message,
        senderType: isDedicatedNumber,
        contacts: [`${data}`],
        longUrl: sendData.longUrl,
        countryCode: '61',
      }

      if (scheduleAt) {
        payload.scheduleAt = scheduleAt
      }

      sendSMSInbox(payload)
        .unwrap()
        .then((res: any) => {
          // Update welcome message sent flag via API if raw contact exists
          if (rawContactId && !isSentWelcomeMessage) {
            updateWelcomeMessageSent({ id: rawContactId, isSentWelcomeMessage: true })
              .unwrap()
              .then(() => {
              })
              .catch((err) => {
                console.error('Failed to update welcome message sent flag:', err)
              })
          }

          setHideWelcome(true)

          if (scheduleAt) {
            fetchInboxMessageDetails(res?.data?.queueResponse.at(0)?.MessageId)
              .unwrap()
              .then((res: any) => {
                toast.success('Message scheduled successfully')
                setItems([res.data, ...items])
              })
          } else {
            fetchInboxMessageDetails(res?.data?.queueResponse.at(0)?.MessageId)
              .unwrap()
              .then((res: any) => {
                toast.success('Message sent successfully')
                setItems([res.data, ...items])
              })
          }
        })
        .catch((e: any) => {
          console.error('API Error:', e)
          toast.error(scheduleAt ? 'Failed to schedule message' : 'Message failed to send')
        })
        .finally(() => {})
    }

    // Reset form
    setSendData({
      ...sendData,
      contacts: [],
      subject: '',
      media: '',
      message: '',
      optout: '',
      alphaId: '',
      gif: '',
    })

    // Reset send later state
    setSendLater(false)
    setLaterDate(getUserTimezoneNow())
  }

  const fetchData = async ({page = 1, limit = 20}) => {
    const response = await fetchInboxMessages({
      sortField: 'createdAt',
      sortOrder: 'descending',
      receiver: data,
      page,
      limit,
    })

    return response
  }

  const initialMessageFetch = async () => {
    setPage({page: 1, limit: 20})
    setItems([])
    const response = await fetchData({limit: 20, page: 1})
    const newData = response?.data?.data?.items

    setItems(newData ?? [])
  }

  const fetchMoreData = async () => {
    try {
      const response = await fetchData({...page})
      const newData = response?.data?.data?.items // adjust this based on your actual response structure

      if (!newData || newData.length === 0) {
        setHasMore(false)
        return
      }

      setItems([...items, ...newData])
      setPage({
        ...page,
        page: page?.page + 1,
      })
    } catch (error) {
      console.error('Error fetching data:', error)
    }
  }

  const downloadData = useCallback(() => {
    downloadArchiveMessage({
      receiver: data,
    })
      .unwrap()
      .then((res) => {
        window.open(`${API_DOMAIN}${res.data.downloadurl}`, '_self')
      })
  }, [API_DOMAIN, data, downloadArchiveMessage])

  const baseListInbox = ['template', 'customfield', 'weblink', 'landingPage', 'opt-out'];
  return (
    <div
      className='card-body'
      id={isDrawer ? 'kt_drawer_chat_messenger_body' : 'kt_chat_messenger_body'}
    >
      <div
        className={clsx('scroll-y me-n5 pe-5', {'h-300px h-lg-auto': !isDrawer})}
        data-kt-element='messages'
        data-kt-scroll='true'
        data-kt-scroll-activate='{default: false, lg: true}'
        data-kt-scroll-max-height='auto'
        data-kt-scroll-dependencies={
          isDrawer
            ? '#kt_drawer_chat_messenger_header, #kt_drawer_chat_messenger_footer'
            : '#kt_header, #kt_toolbar, #kt_footer, #kt_chat_messenger_header, #kt_chat_messenger_footer'
        }
        data-kt-scroll-wrappers={
          isDrawer ? '#kt_drawer_chat_messenger_body' : '#kt_content, #kt_chat_messenger_body'
        }
        data-kt-scroll-offset={isDrawer ? '0px' : '-2px'}
      >
        {data !== '' && (
          <>
            <div
              id='scrollableDiv'
              ref={scrollRef}
              style={{
                height: 'calc(100vh - 500px) !important',
                overflow: 'auto',
                display: 'flex',
                flexDirection: 'column-reverse',
              }}
            >
              <InfiniteScroll
                dataLength={items.length}
                next={fetchMoreData}
                hasMore={hasMore}
                loader={<h4>Loading...</h4>}
                style={{display: 'flex', flexDirection: 'column-reverse', overflow: 'hidden'}} //To put endMessage and loader to the top.
                inverse={true} //
                scrollableTarget='scrollableDiv'
              >
                {items?.length > 0 &&
                  [...items]?.map((message: any, index: any) => {
                    // const userInfo = message?.adminDetails?._id !== SigninUser
                    const userInfo = !['notification', 'promotional']?.includes(
                      message?.campaign_type
                    )
                    const templateAttr = {}

                    return (
                      <React.Fragment key={index}>
                        {
                          <>
                            <div
                              key={`message${index}`}
                              className={clsx(
                                'd-flex',
                                'mb-10',
                                {'d-none': message.template},
                                {'flex-row-reverse': !userInfo}
                              )}
                              {...templateAttr}
                            >
                              <div
                                className={clsx(
                                  'd-flex flex-column align-items',
                                  `align-items-${userInfo ? 'start' : 'end'}`
                                )}
                              >
                                {userInfo ? (
                                  <>
                                    <div className='d-flex align-items-center mb-2'>
                                      <div className='symbol  symbol-35px symbol-circle '>
                                        {/* <span className='circle1'>
                                        {!message?.user?.avatar ? (
                                            <span className='circle1'>{`${
                                              createFirstLetter(message?.user?.name)?.firstName ??
                                              'C'
                                            }${
                                              createFirstLetter(message?.user?.name).lastName ?? 'C'
                                            }`}</span>
                                          ) : (
                                            <img src={message?.user?.avatar} alt='Profile Pic' />
                                          )}
                                        </span> */}
                                        <img src={'/media/avatars/blank.png'} alt='Profile Pic' />
                                      </div>
                                      <div className='ms-3'>
                                        <a className='fs-5 fw-bolder text-gray-900 text-hover-primary me-2'>
                                          {messengerName}
                                        </a>
                                        <div className='fs-7 text-muted mb-1'>{message.sender}</div>
                                      </div>
                                    </div>
                                  </>
                                ) : (
                                  <>
                                    <div className='d-flex flex-row- align-items-center mb-2'>
                                      <div className='me-3'>
                                        <a
                                          href='#'
                                          className='fs-5 fw-bolder text-gray-900 text-hover-primary ms-2'
                                        >
                                          {message?.createdBy?.name}
                                        </a>
                                        <div className='text-muted fs-7 mb-1 ms-2'>
                                          {message.sender}
                                        </div>
                                      </div>
                                      <div className='symbol  symbol-35px symbol-circle '>
                                        {!message?.createdBy?.avatar ||
                                        message?.createdBy?.avatar === 'undefined' ? (
                                          <span className='circle1'>{`${
                                            createFirstLetter(message?.createdBy?.name)
                                              ?.firstName ?? 'C'
                                          }${
                                            createFirstLetter(message?.createdBy?.name).lastName ??
                                            'C'
                                          }`}</span>
                                        ) : (
                                          <img src={message?.createdBy?.avatar} alt='Profile Pic' />
                                        )}
                                      </div>
                                    </div>
                                  </>
                                )}

                                <div
                                  // style={{backgroundColor:"#7950F2"}}
                                  className={clsx(
                                    'p-2 rounded',
                                    `bg-light-${userInfo ? 'info' : 'sender'}`,
                                    `text-${userInfo ? 'dark' : 'light'}`,
                                    'fw-bold mw-lg-400px',
                                    `text-${userInfo ? 'start' : 'end'}`
                                  )}
                                  data-kt-element='message-text'
                                  // dangerouslySetInnerHTML={{__html: message.text}}
                                >
                                  {(message?.media?.length > 0 ||
                                    message?.customerResponseMedia?.length > 0) && (
                                    <>
                                      {(message?.media || message?.customerResponseMedia || []).map(
                                        (media: any, index: number) => (
                                          <img
                                            className='m-2 cursor-pointer'
                                            key={index} // Use a unique key for each element (e.g., index or a unique ID from the media object)
                                            src={media.url} // Use the URL from the media object
                                            width='100px'
                                            height='100px'
                                            alt={`Media ${index + 1}`} // Provide a meaningful alt text
                                            onClick={() => {
                                              window.open(media.url, '_blank')
                                            }}
                                          />
                                        )
                                      )}
                                      <br />
                                    </>
                                  )}
                                  {message?.message}
                                </div>
                                {userInfo ? (
                                  <span
                                    className='text-muted fs-7 mb-1'
                                    title={`${moment(message?.createdAt)?.format(
                                      'DD/MM/YYYY hh:mm A'
                                    )} | ${message?.status}`}
                                  >
                                    {moment(message?.createdAt)?.fromNow()} (
                                    {moment(message?.createdAt)?.format('DD/MM/YYYY hh:mm A')})
                                  </span>
                                ) : (
                                  <div className='d-flex align-items-center mb-1 gap-2'>
                                    <span
                                      title={`${moment(
                                        message?.scheduleAt || message?.send_time
                                      )?.format('DD/MM/YYYY hh:mm A')} | ${message?.status}`}
                                      className='text-muted fs-7'
                                    >
                                      {moment(message?.scheduleAt || message?.send_time)?.fromNow()}{' '}
                                      (
                                      {moment(message?.scheduleAt || message?.send_time)?.format(
                                        'DD/MM/YYYY hh:mm A'
                                      )}
                                      )
                                    </span>

                                    {(() => {
                                      const status = message?.status

                                      if (
                                        [
                                          MessageDeliveryStatus.DELIVERED,
                                          MessageDeliveryStatus.SEND,
                                        ].includes(status)
                                      ) {
                                        return (
                                          <i
                                            className='bi bi-check-circle text-success'
                                            title={status}
                                          ></i>
                                        )
                                      }

                                      if (status === MessageDeliveryStatus.QUEUED) {
                                        return (
                                          <i
                                            className='bi bi-exclamation-circle'
                                            title={status}
                                          ></i>
                                        )
                                      }

                                      if (status === MessageDeliveryStatus.SCHEDULED) {
                                        return <i className='bi bi-clock' title={status}></i>
                                      }

                                      // Fallback for any other status (e.g. FAILED)
                                      return (
                                        <i
                                          className='bi bi-x-circle text-danger'
                                          title={status}
                                        ></i>
                                      )
                                    })()}
                                  </div>
                                )}
                              </div>
                            </div>
                          </>
                        }
                      </React.Fragment>
                    )
                  })}

                {isHaveArchiveMessage && !hasMore && (
                  <div className='d-flex justify-content-center w-100 mx-10'>
                    <button
                      onClick={() => downloadData()}
                      className='btn btn-sm btn-light mx-5 fw-500'
                    >
                      {downloadLoading || downloadFetching ? (
                        <Spinner size='sm' />
                      ) : (
                        <>
                          <i className='bi bi-archive'></i> Download Archive Message
                        </>
                      )}
                    </button>
                  </div>
                )}
              </InfiniteScroll>
            </div>
          </>
        )}
      </div>
      {inboxFetching && page.page < 2 && (
        <div className='text-center my-3'>
          <div className='px-2'>
            {[...Array(3)].map((_, idx) => (
              <MessageSkeleton key={idx} />
            ))}
          </div>
        </div>
      )}
      {sendLoading && (
        <div className='text-center my-3'>
          <div> Sending message...</div>
          <Spinner
            size='sm'
            variant='primary'
            style={{width: '2rem', height: '2rem', borderWidth: '0.2rem'}}
          />
        </div>
      )}

      {AuthenticateUser('send-quick-sms') && (
        <>
          {data !== '' && (
            <>
              <div className='mb-7 mt-10 form-group '>
                {/* <Select
                  onChange={(e: any) => {
                    setSendData({...sendData, sender: e})
                  }}
                  className='form-select bg-light-primary border-0 '
                  aria-label='Select example'
                  options={[
                    {
                      label: 'Dedicated Number',
                      options: virtualNumber?.map((key: any) => {
                        return {
                          value: key.audNumber,
                          label: `${key.audNumber}`,
                        }
                      }),
                    },
                    {
                      label: 'Bussiness Name',
                      options: bussinessName?.map((key: any) => {
                        return {
                          value: key.businessname,
                          label: `${key.businessname}`,
                        }
                      }),
                    },
                  ]}
                /> */}
                {/* <select
                  className='form-select bg-light-primary border-0 '
                  aria-label='Select example'
                  value={sendData?.sender}
                >
                  <option value={'#SharedNum#'}>#SharedNum#</option>
                  <option value={'Alpha_id'}>Alpha_ID</option>
                  {virtualNumber?.map(
                    (val: any) =>
                      val?.type == 'SMS' && (
                        <option key={val?.audNumber} value={val?.audNumber}>
                          {val?.audNumber}
                        </option>
                      )
                  )}
                  {bussinessName?.map((val: any) => (
                    <option key={val?._id} value={val?.businessname}>
                      {val?.businessname}
                    </option>
                  ))}
                </select> */}
              </div>
              {welcomeMessage && !hideWelcome && (
                <div className='d-flex mb-4'>
                  <div
                    className='bg-light-primary border rounded-3 shadow-sm position-relative welcome-bubble'
                    role='region'
                    aria-label='Suggested welcome message'
                  >
                    <div className='welcome-bubble-header'>
                      <i className='bi bi-chat-quote-fill text-primary me-2'></i>
                      <span className='welcome-bubble-title'>Suggested welcome message</span>
                    </div>
                    <button
                      type='button'
                      aria-label='Close'
                      className='btn-close position-absolute welcome-bubble-close'
                      onClick={() => {
                        setHideWelcome(true)
                      }}
                    />
                    <div className='welcome-bubble-content'>{welcomeMessage}</div>
                    <div className='d-flex justify-content-start'>
                      <button
                        type='button'
                        className='btn btn-primary fw-semibold welcome-bubble-use-btn'
                        onClick={() => {
                          setSendData({...sendData, message: welcomeMessage})
                          setHideWelcome(true)
                        }}
                      >
                        Use
                      </button>
                    </div>
                  </div>
                </div>
              )}
              {welcomeMessage && hideWelcome && (
                <div className='d-flex justify-content-end mb-4'>
                  <button
                    type='button'
                    className='button-ai-suggestions fw-semibold border-0 shadow-sm'
                    onClick={async () => {
                      try {
                        const response = await generateFollowup({contactId: String(data)}).unwrap()
                        const suggestion = response.data?.suggestion ?? null

                        if (!suggestion) {
                          toast.info(
                            'No recent lead message found to generate AI suggestion. Using voice-based suggestion instead.'
                          )
                          setHideWelcome(false)
                          return
                        }

                        setSendData((prev: typeof sendData) => ({
                          ...prev,
                          message: suggestion,
                        }))
                      } catch (err) {
                        console.error('Failed to generate AI follow-up suggestion:', err)
                        toast.error('Failed to generate AI suggestion. Please try again.')
                      }
                    }}
                    aria-label='Open suggested message'
                    disabled={isGeneratingFollowup}
                  >
                    {isGeneratingFollowup ? (
                      <>
                        <Spinner
                          as='span'
                          animation='border'
                          size='sm'
                          role='status'
                          aria-hidden='true'
                          className='me-2'
                        />
                        Generating...
                      </>
                    ) : (
                      <>
                        <i className='bi bi-stars me-2 text-white'></i>
                        AI Suggestions
                      </>
                    )}
                  </button>
                </div>
              )}
            </>
          )}
          <MessageBoxV2
            setError={setError}
            disableTextfield={data === ''}
            setUserMessage={setSendData}
            userMessage={sendData}
            options={options}
            quickSms={true}
            onlyStop={true}
            showSelect={
              isMobile
                ? [...baseListInbox, 'review-template']
                : baseListInbox
            }
            isInbox={true}
            isRMSChat={isRMSChat}
            isMobile={isMobile}
          />

          {/* Send Later Section */}
          <div className='mb-4'>
            <div className='form-check'>
              <input
                className='form-check-input me-5'
                type='checkbox'
                id='sendLaterCheck'
                checked={sendLater}
                onChange={() => setSendLater(!sendLater)}
              />
              <label className='form-check-label' htmlFor='sendLaterCheck'>
                Send Later
              </label>
            </div>

            {sendLater && (
              <div className='mt-3 p-3 bg-light rounded'>
                <label className='form-label mb-2'>
                  Select Date & Time <span className='text-muted'>{timezoneLabel}</span>
                </label>
                <DatePicker
                  minDate={getUserTimezoneNow()}
                  dateFormat='MMMM d, yyyy h:mm aa'
                  placeholderText='Select a date and time'
                  showTimeSelect
                  className='form-control form-control-lg form-control-solid'
                  onChange={(date: Date) => {
                    if (new Date(date) > getUserTimezoneNow()) {
                      setLaterDate(date)
                    } else {
                      setLaterDate(date)
                      toast.error('Please select a future date and time')
                    }
                  }}
                  selected={laterDate}
                />
                {laterDate && new Date(laterDate) > getUserTimezoneNow() && (
                  <div className='mt-2'>
                    <small className='text-muted'>
                      Scheduled for: {moment(laterDate).format('MMMM Do YYYY, h:mm A')}
                    </small>
                  </div>
                )}
                {laterDate && new Date(laterDate) <= getUserTimezoneNow() && (
                  <div className='mt-2'>
                    <small className='text-danger'>
                      Please select a future date and time. Current time is{' '}
                      {moment(getUserTimezoneNow()).format('MMMM Do YYYY, h:mm A')}
                    </small>
                  </div>
                )}
              </div>
            )}
          </div>

          {!isMobile ? (
            <Dropdown as={ButtonGroup} drop='up-centered'>
              <Button
                variant='primary'
                className='p-0 p-3'
                onClick={handleSubmit}
                disabled={sendLoading || (sendLater && new Date(laterDate) <= getUserTimezoneNow())}
              >
                {sendLoading ? (
                  <div>
                    <span className='ml-3'>{sendLater ? 'Scheduling...' : 'Sending...'}</span>
                  </div>
                ) : sendLater ? (
                  'Schedule SMS'
                ) : (
                  'Send SMS'
                )}
              </Button>

              <Dropdown.Toggle
                split
                variant='primary'
                className='p-0 px-5'
                id='dropdown-split-basic'
                disabled={sendLoading}
              >
                <i className='bi bi-chevron-down p-0'></i>
              </Dropdown.Toggle>

              <Dropdown.Menu>
                {isRMSChat ? (
                  <Dropdown.Item
                    onClick={() => {
                      setIsRMSChat(false)
                    }}
                  >
                    Convert to SMS/MMS Messaging
                  </Dropdown.Item>
                ) : (
                  <Dropdown.Item
                    onClick={() => {
                      setIsRMSChat(true)
                    }}
                  >
                    Convert to Rich Messaging
                  </Dropdown.Item>
                )}
              </Dropdown.Menu>
            </Dropdown>
          ) : (
            <div className="d-grid gap-2 w-100">
              <Button
                variant="primary"
                onClick={handleSubmit}
                disabled={sendLoading || (sendLater && new Date(laterDate) <= getUserTimezoneNow())}
                size="lg"
              >
                {sendLoading ? (
                  <div>
                    <span className="ml-3">{sendLater ? 'Scheduling...' : 'Sending...'}</span>
                  </div>
                ) : sendLater ? (
                  'Schedule'
                ) : (
                  'Send Message'
                )}
              </Button>

              <a href={`tel:${data}`} style={{ textDecoration: 'none' }}>
                <Button variant="success" size="lg" className="w-100">
                  Call Customer
                </Button>
              </a>
            </div>
          )}
        </>
      )}
    </div>
  )
}

export default InboxChatInner
